const protocol = 'https:';
// app中不认//开头的地址，必须加协议

const cdnConfig = {
  DEV: `${protocol}//cdn-dev.riselinkedu.com`,
  TEST: `${protocol}//cdn-test.riselinkedu.com`,
  STAGE: `${protocol}//cdn-stage.riselinkedu.com`,
  DEMO: `${protocol}//cdn01.riselinkedu.com`,
  PROD: `${protocol}//cdn01.riselinkedu.com`,
  LOCAL: '',
};

module.exports = cdnConfig;
